// extracted by mini-css-extract-plugin
export var feature = "feature-grid-module--feature--02a85";
export var featureSingle = "feature-grid-module--featureSingle--f9074";
export var features = "feature-grid-module--features--997c4";
export var featuresSingle = "feature-grid-module--featuresSingle--686f9";
export var root = "feature-grid-module--root--6f809";